// useUserAgent.ts
import { useMemo } from 'react'

interface UserAgentInfo {
  isMobile: boolean
  isTablet: boolean
  isDesktop: boolean
  isIOS: boolean
  isAndroid: boolean
  userAgent: string
}

function computeUserAgentInfo(): UserAgentInfo {
  if (typeof window === 'undefined') {
    return {
      isMobile: false,
      isTablet: false,
      isDesktop: true,
      isIOS: false,
      isAndroid: false,
      userAgent: '',
    }
  }

  const ua = navigator.userAgent

  const isAndroid = /Android/i.test(ua)
  const isIOS = /iPhone|iPad|iPod/i.test(ua)
  const isTablet = /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)
  // Drive the mobile shell off the user agent only. A narrow desktop window
  // (e.g. split to half a screen) is still a desktop user and must stay on the
  // desktop app (FIR-7538). User-agent detection is also testable in Chrome via
  // the DevTools device toolbar, which overrides navigator.userAgent.
  const isMobile =
    /Mobile|Android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua) &&
    !isTablet

  return {
    isMobile,
    isTablet,
    isDesktop: !isMobile && !isTablet,
    isIOS,
    isAndroid,
    userAgent: ua,
  }
}

export function useUserAgent(): UserAgentInfo {
  // The user-agent regexes never change after load, so this is computed once.
  return useMemo(() => computeUserAgentInfo(), [])
}
